function CustomMap() {

	// let map = new Map(document.getElementById("map"), {
	// 	center: { lat: -34.397, lng: 150.644 },
	// 	zoom: 8,
	// });

	let mapElement = document.getElementById("map");

	if( !mapElement ){
		return;
	}

	let inner = mapElement.querySelector('.map-inner');

	let map = new google.maps.Map(inner, {
		zoom: 12,
		clickableIcons: false,
		streetViewControl: false,
		mapTypeControl: false,
		fullscreenControl: false,
		zoomControl: false,
		gestureHandling: "cooperative",
		mapId: "6ff68edf5d1d30ef"
	});

	let m = new google.maps.Marker({
		position: {
			lat: parseFloat(mapElement.dataset.lat),
			lng: parseFloat(mapElement.dataset.lng)
		},
		map: map
	});

	map.setCenter(m.getPosition());

}